export default __webpack_public_path__ + "static/media/logo_k.126f8dff.png";